import convict from 'convict';
import convict_format_with_validator from 'convict-format-with-validator';
import json5 from 'json5';

convict.addFormats(convict_format_with_validator as unknown as { [name: string]: convict.Format });
convict.addParser({ extension: 'json5', parse: json5.parse });

export default convict;
